export default __webpack_public_path__ + "static/media/oops.2af367f2.png";